// Detail menu of the live spectrogram (user 13 Oct 2026): the automatic window keeps the zoomed-out detail; the user
// can trade it for sharper timing (shorter window) or sharper frequencies (longer window). Shows the window used.
import React from 'react';

const LABELS = { '-3': 'time ×8', '-2': 'time ×4', '-1': 'time ×2', 0: 'automatic', 1: 'frequency ×2', 2: 'frequency ×4', 3: 'frequency ×8' };
const fmtMs = (ms) => (ms >= 100 ? `${Math.round(ms)} ms` : `${ms.toFixed(ms >= 10 ? 0 : 1)} ms`);
const fmtHz = (hz) => (hz >= 10 ? `${Math.round(hz)} Hz` : `${hz.toFixed(1)} Hz`);

export default function DetailSelect({ value, onChange, info }) {
  return (
    <label className="hcr-small" title="Sharper in time = shorter analysis window (timing, pulses); sharper in frequency = longer window (fine pitch, close harmonics). Automatic keeps the zoomed-out detail when you zoom in.">
      Detail <select className="hcr-input cr-speed" value={value} onChange={(e) => onChange(Number(e.target.value))}>
        {[-3, -2, -1, 0, 1, 2, 3].map((k) => <option key={k} value={k}>{k < 0 ? `sharper ${LABELS[k]}` : k > 0 ? `sharper ${LABELS[k]}` : LABELS[0]}</option>)}
      </select>
      {info && <span className="ct-muted"> window {fmtMs(info.ms)} · {fmtHz(info.hz)}</span>}
    </label>
  );
}
